// Copyright (c) Microsoft Corporation. All rights reserved.
import { Trilean } from '../typings';
export const hasTizenApi = () => typeof window !== 'undefined' && window.tizen != null;
export const hasTizenWebapi = () => typeof window !== 'undefined' && window.webapis != null;
/**
 * Calls Tizen API to get platform specific system information.
 */
export async function getTizenSystemInformation() {
    if (hasTizenApi()) {
        return new Promise((resolve, reject) => {
            tizen.systeminfo.getPropertyValue('BUILD', (property) => resolve(property), (error) => reject(error));
        });
    }
    return undefined;
}
export function isTizenTvMicrophoneSupported() {
    var _a, _b, _c, _d;
    if (hasTizenWebapi()) {
        const smartTvServerVersion = (_d = (_c = (_b = (_a = webapis.productinfo) === null || _a === void 0 ? void 0 : _a.getSmartTVServerVersion()) === null || _b === void 0 ? void 0 : _b.split('T-INFOLINK')) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.split('-');
        const tizenAppsServerYear = parseInt(smartTvServerVersion === null || smartTvServerVersion === void 0 ? void 0 : smartTvServerVersion[0], 10);
        // TODO: enable for 2021 and 2022 TV when updated firmware version is available with fixes
        // https://microsoft.visualstudio.com/Xbox/_workitems/edit/42264520
        // const tizenAppsServerVersion = parseInt(smartTvServerVersion?.[1], 10);
        if (!isNaN(tizenAppsServerYear)) {
            const isSupported = tizenAppsServerYear >= 2023;
            // tizenAppsServerYear === 2021 ||
            // tizenAppsServerYear === 2020 ||
            // (tizenAppsServerYear === 2022 &&
            //     tizenAppsServerVersion >= 1008);
            return isSupported ? Trilean.YES : Trilean.NO;
        }
    }
    return Trilean.UNKNOWN;
}
//# sourceMappingURL=tizenHelper.js.map